<template>
  <dialog-big
    :title="dialogTitle"
    :visible.sync="isVisibleDialog"
  >
    <div v-loading="this.isLoading">
      <form-editor
        :data="data"
        :model="popupModel"
        ref="Form"
        :rulesBaxPO="rulesBaxPO"
      >
        <template v-slot:right-info>
          <more-quotes-grid-chosen :listSelectedQuotes="listSelectedQuotesChosen" />
        </template>
      </form-editor>
      <div class="row">
        <div class="col-12">
          <more-quotes-grid
            :data="dataRFQ2"
            :listSelectedQuotes="listSelectedQuotes"
            @update:listSelectedQuotes="$emit('update:listSelectedQuotes', $event)"
          />
        </div>
      </div>
    </div>
    <template v-slot:footer>
      <form-controls
        class="form-footer"
        isCancel
        isCreate
        @command="setCommand"
      >
        <div class="control btn-mobile-full">
          <button type="button" class="btn btn-border blue btn-size-s" @click="onFill('France')">
            {{L10n('stock-france')}}
          </button>
        </div>
        <div class="control btn-mobile-full" style="margin-right: auto">
          <button type="button" class="btn btn-border blue btn-size-s" @click="onFill('USA')">
            {{L10n('stock-usa')}}
          </button>
        </div>
      </form-controls>
    </template>
  </dialog-big>
</template>

<script>
import { ServiceRFQs, ModelFrance, ModelUSA, ModelSharedForm } from '@/services/RFQs'
import { setToModel } from '@/utils/objects'

export default {
  name: 'ModalCreatePO',
  components: {
    'form-editor': () => import(/* webpackChunkName: 'SupplierQuotesRFQ2' */ './CreatePOForm.vue'),
    'dialog-big': () => import(/* webpackChunkName: 'Layouts' */ '@/components/Layouts/DialogBig'),
    'more-quotes-grid': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQSupplierMoreQuotesGrid/Index.vue'),
    'more-quotes-grid-chosen': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/RFQSupplierMoreQuotesGridChosen/Index.vue'),
    'form-controls': () => import(/* webpackChunkName: 'Forms' */ '@/components/Form/FormControls')
  },
  props: {
    listSelectedQuotes: { type: Array },
    dataRFQ2: { type: Object },
    actionName: { type: String, required: true }
  },
  data () {
    return {
      isVisibleDialog: false,
      isLoading: false,
      data: {}
    }
  },
  computed: {
    dialogTitle () {
      if (this.actionName === 'create-wo') {
        return this.L10n('create-wo')
      } else {
        return this.L10n('create-po')
      }
    },
    listSelectedQuotesChosen () {
      let currentRFQ2 = { ...this.dataRFQ2 }
      let list = [currentRFQ2].concat(this.listSelectedQuotes)
      return list
    },
    defaultRfqTypeID () {
      if (this.actionName === 'create-wo') {
        return 5
      } else if (this.actionName === 'create-supplier-po') {
        return 4
      } else {
        return 3
      }
    },
    rulesBaxPO () {
      if (this.actionName === 'create-wo') {
        return this.ruleActionWO
      } else if (this.actionName === 'create-supplier-po') {
        return this.ruleActionSupplierPO
      } else {
        return []
      }
    },
    ruleActionWO () {
      return [
        {
          validator: (rule, value, cb) => {
            const val = String(value)
            if (val.startsWith('W')) {
              cb()
            } else {
              cb(new Error(this.L10n('validation-rule-start-w')))
            }
          }
        }
      ]
    },
    ruleActionSupplierPO () {
      return []
    }
  },
  methods: {
    FranceModel () {
      return ModelFrance()
    },
    USAModel () {
      return ModelUSA()
    },
    popupModel () {
      return setToModel(ModelSharedForm(), { rfqTypeID: this.defaultRfqTypeID })
    },
    onFill (country) {
      let fillModel = {}
      if (country === 'USA') {
        fillModel = this.USAModel()
      }
      if (country === 'France') {
        fillModel = this.FranceModel()
      }
      this.data = { ...this.$refs.Form.getData(), ...fillModel }
    },
    open (config) {
      this.resetData()
      this.isVisibleDialog = true
    },
    setCommand (command) {
      switch (command) {
        case 'save':
          this.create()
          break
        case 'cancel':
          this.cancel()
          break
      }
    },
    resetData () {
      this.data = {}
    },
    create () {
      let form = this.$refs['Form']
      form.validate()
        .then(() => {
          let dataPopup = this.data = { ...form.getData() }
          return this.requestCreatePO(dataPopup)
        })
    },
    cancel () {
      this.isVisibleDialog = false
    },
    requestCreatePO (dataPopup) {
      this.isLoading = true

      ServiceRFQs
        .createRFQAndPO({ dataRFQ: dataPopup, sharedData: dataPopup, listRFQ2s: [this.dataRFQ2, ...this.listSelectedQuotes] })
        .then(({ data }) => {
          this.requestSuccessHandler()
          this.$emit('on-created-po', data.rfq.id, data.salesOrder.id)
          this.cancel()
        })
        .catch((error) => {
          this.requestErrorHandler(error)
        })
        .finally(() => {
          this.isLoading = false
        })
    }
  }
}
</script>
